import { IValueLabel } from 'src/ts/interfaces';

// ITL-2953 no-income completion reasons. The numeric codes mirror the backend's
// boundary map in ReviewController (source of truth: ReviewItem.completion_reasons/0).
export const NO_INCOME_REASON_OPTIONS: IValueLabel[] = [
  { value: '', label: 'Select a reason', isPlaceHolder: true },
  { value: '4101', label: 'Business bank statements' },
  { value: '4102', label: 'CPA letter incomplete' },
  { value: '4103', label: 'CPA statement unverified' },
  { value: '4105', label: 'International paystubs (not in English / not USD)' },
  { value: '4111', label: 'International bank statements (not in English / not USD)' },
  { value: '4106', label: 'No recurring income pattern' },
  { value: '4112', label: 'Single asset statement — unable to calculate average ending balance' },
  { value: '4108', label: 'Support docs insufficient' },
  { value: '4107', label: 'Offer letter' },
  { value: '4109', label: 'Unsupported document type' },
  { value: '4113', label: 'Paystubs non-consecutive' },
  { value: '4114', label: 'Paystubs do not cover 28-day period' },
  { value: '4115', label: 'Tax transcripts outdated' },
  { value: '4116', label: 'Name Mismatch' },
  { value: '4110', label: 'Other' }
];
